@let canReadUserQualificationV2Attachment =
  can(RoleAction.Read, RolePermissionSubject.UserQualificationV2);
@let canCreateUserQualificationV2Attachment =
  can(RoleAction.Create, RolePermissionSubject.UserQualificationV2Attachment);
@let canDeleteUserQualificationV2Attachment =
  can(RoleAction.Delete, RolePermissionSubject.UserQualificationV2Attachment);
<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="
      customHeader ? customHeader : ('general.attachments' | translate)
    "
    [nzActive]="canReadUserQualificationV2Attachment === false ? false : active"
    [nzCollapsible]="
      (canReadUserQualificationV2Attachment === false ? true : disabled)
        ? 'disabled'
        : undefined
    "
    nz-tooltip
    [nzTooltipTitle]="'general.no_permissions' | translate"
    [nzTooltipTrigger]="
      canReadUserQualificationV2Attachment === false ? 'hover' : null
    "
  >
    <!-- https://gitlab.com/menlo79/wilson-backend/-/blob/main/apps/api-gateway/src/qualifications/user-qualification-attachments/user-qualification-attachments.controller.ts#L45 -->
    <nz-upload
      [(nzFileList)]="fileList"
      [nzBeforeUpload]="beforeUpload"
      [nzType]="'drag'"
      [nzMultiple]="true"
      [nzSize]="maxFileSizeInBytes"
      [nzFileType]="'image/jpeg,application/pdf'"
      [nzAccept]="'image/jpeg,application/pdf'"
      [nzDisabled]="
        canCreateUserQualificationV2Attachment === false
          ? true
          : disabledNzUpload
      "
      [ngClass]="{
        'disabled-nz-upload-list':
          canDeleteUserQualificationV2Attachment === false
            ? true
            : disabledFileList,
      }"
    >
      <span nz-icon nzType="upload"></span>
      {{ 'general.upload' | translate }}
    </nz-upload>
    <div class="attachment-upload-info">
      {{
        customInfo
          ? customInfo
          : ('user_qualifications.attachments.upload.info' | translate)
      }}
    </div>
  </nz-collapse-panel>
</nz-collapse>
